// Aurora Innovation, Inc. Proprietary and Confidential. Copyright 2026.
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { Accordion } from '../components/Accordion/Accordion';
import { Alert } from '../components/Alert/Alert';
import { AppBar } from '../components/AppBar/AppBar';
import { Autocomplete } from '../components/Autocomplete/Autocomplete';
import { Avatar } from '../components/Avatar/Avatar';
import { AvatarGroup } from '../components/AvatarGroup/AvatarGroup';
import { Backdrop } from '../components/Backdrop/Backdrop';
import { Badge } from '../components/Badge/Badge';
import { Breadcrumbs } from '../components/Breadcrumbs/Breadcrumbs';
import { Button } from '../components/Button/Button';
import { ButtonGroup } from '../components/ButtonGroup/ButtonGroup';
import { Card } from '../components/Card/Card';
import { Checkbox } from '../components/Checkbox/Checkbox';
import { Chip } from '../components/Chip/Chip';
import { CssBaseline } from '../components/CssBaseline/CssBaseline';
import { Dialog } from '../components/Dialog/Dialog';
import { Divider } from '../components/Divider/Divider';
import { Drawer } from '../components/Drawer/Drawer';
import { Fab } from '../components/Fab/Fab';
import { IconButton } from '../components/IconButton/IconButton';
import { Link } from '../components/Link/Link';
import { List } from '../components/List/List';
import { Menu } from '../components/Menu/Menu';
import { Paper } from '../components/Paper/Paper';
import { ProgressBar } from '../components/ProgressBar/ProgressBar';
import { Radio } from '../components/Radio/Radio';
import { Rating } from '../components/Rating/Rating';
import { Select } from '../components/Select/Select';
import { Skeleton } from '../components/Skeleton/Skeleton';
import { Slider } from '../components/Slider/Slider';
import { Snackbar } from '../components/Snackbar/Snackbar';
import { SvgIcon } from '../components/SvgIcon/SvgIcon';
import { Switch } from '../components/Switch/Switch';
import { Tab } from '../components/Tab/Tab';
import { Table } from '../components/Table/Table';
import { TablePagination } from '../components/TablePagination/TablePagination';
import { Tabs } from '../components/Tabs/Tabs';
import { TextField } from '../components/TextField/TextField';
import { ToggleButton } from '../components/ToggleButton/ToggleButton';
import { Tooltip } from '../components/Tooltip/Tooltip';
import { TreeView } from '../components/TreeView/TreeView';
export var getComponentOverrides = function(mode) {
    return _object_spread({}, Accordion(mode), Alert(mode), AppBar(mode), Autocomplete(mode), Avatar(mode), AvatarGroup(mode), Backdrop(mode), Badge(mode), Breadcrumbs(mode), Button(mode), ButtonGroup(mode), Card(mode), Checkbox(mode), Chip(mode), CssBaseline(mode), Dialog(mode), Drawer(mode), Divider(mode), Fab(mode), IconButton(mode), Link(mode), List(mode), Menu(mode), Paper(mode), ProgressBar(mode), Radio(mode), Rating(mode), Select(mode), Skeleton(mode), Slider(mode), Snackbar(mode), SvgIcon(mode), Switch(mode), Table(mode), TablePagination(mode), Tab(mode), Tabs(mode), TextField(mode), ToggleButton(mode), Tooltip(mode), TreeView(mode));
};

//# sourceMappingURL=getComponentOverrides.js.map